import React from 'react';
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Loading from '../components/loading/Loading';
import NavbarLog from '../components/NavbarLog';
import Footer from '../components/Footer';
import "../css/TnC.css";


export default function About() {
  const [ENcontent, setENContent] = useState(null);
  const [FAcontent, setFAContent] = useState(null);
  const [consoleError, setConsoleError] = useState("");
  const [setlang, setLang] = useState("fa")
  const { lang } = useParams();
  

  useEffect(() => {
    fetch("/data/ReturnPolicy.json")
      .then((res) => res.json())
      .then((data) => (setENContent(data.EN), setFAContent(data.FA)))
      .catch((err) => setConsoleError("Error loading content:", err));
  }, []);


  useEffect (() => {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if(lang !== "fa" && lang !== "en") {
      if ( userTimezone === "Asia/Tehran") {
        setLang(`fa`);
      } else {
        setLang(`en`);
        
      }
    } else {
      setLang(lang)
    }
  }, [lang])

  
  if (!FAcontent) return <Loading />;  

  return (
    <>
      <NavbarLog />
      {setlang==="en"?
        <div className="tnc-page-en">
          <div className="tnc-grid-en">
            <h1>{ENcontent.h1}</h1>
            <p>{ENcontent.p1}</p>
            {ENcontent.Services.map((sec, idx) => (
              <div className="tnc-section-en" key={idx}>
                <h2>{sec.title}</h2>
                <p>{sec.content}</p>
              </div>
            ))}
          </div>
        </div>
        :
        <div className="tnc-page-fa">
          <div className="tnc-grid-fa">
            <h1>{FAcontent.h1}</h1>
            <p>{FAcontent.p1}</p>
            {FAcontent.Services.map((sec, idx) => (
              <div className="tnc-section-fa" key={idx}>
                <h2>{sec.title}</h2>
                <p>{sec.content}</p>
              </div>
            ))}
          </div>
        </div>
      }
      <Footer />
    </>
  );
}